export default {
  setup: function (storyboard) {
    let timeout = undefined
    storyboard.DOM.navigator = document.getElementById('navigatorAndButtonsContainer')

    storyboard.viewer.addHandler('zoom', () => {
      let currentZoom = storyboard.viewer.viewport.viewportToImageZoom(storyboard.viewer.viewport.getZoom())

      currentZoom = Math.round((currentZoom / storyboard.viewer.viewport.maxZoomPixelRatio) * 100)

      currentZoom = Math.max(1, currentZoom)

      let currentZoomString = `${currentZoom}%`
      const zoomValueElement = document.getElementById('zoom-value')
      if (zoomValueElement) {
        zoomValueElement.innerHTML = currentZoomString
      }
    })

    storyboard.viewer.addHandler('animation', () => {
      if (!storyboard.DOM.disableNavigator) {
        this.show(storyboard)
        clearTimeout(timeout)
        timeout = setTimeout(() => this.hide(storyboard), 1500)
      }
    })

    document.addEventListener('mousemove', () => {
      if (!storyboard.DOM.disableNavigator) {
        this.show(storyboard)
        clearTimeout(timeout)
        timeout = setTimeout(() => this.hide(storyboard), 1500)
      }
    })

    storyboard.DOM.navigator.addEventListener('mouseenter', () => {
      if (!storyboard.DOM.isAnimating) {
        storyboard.DOM.zoomInBtn.style['opacity'] = '0.8'
        storyboard.DOM.zoomInBtn.classList.remove('disabled')
        storyboard.DOM.zoomOutBtn.style['opacity'] = '0.8'
        storyboard.DOM.zoomOutBtn.classList.remove('disabled')
      }
    })

    storyboard.DOM.navigator.addEventListener('mouseleave', () => {
      storyboard.DOM.zoomInBtn.style['opacity'] = '0'
      storyboard.DOM.zoomInBtn.classList.add('disabled')
      storyboard.DOM.zoomOutBtn.style['opacity'] = '0'
      storyboard.DOM.zoomOutBtn.classList.add('disabled')
    })
  },

  show: function (storyboard) {
    storyboard.DOM.navigator.style['opacity'] = '0.9'
  },

  hide: function (storyboard) {
    storyboard.DOM.navigator.style['opacity'] = '0'
  },

  clear: function () {
    document.getElementById('jarvisNavigator').innerHTML = ''
  }
}
